import { NavLink } from "react-router-dom";
import { Post } from "../contexts/AppContext";

const PostList = ({ posts, className = '' }: { posts: Post[], className?: string }) => (
    <ul className={`space-y-5 ${className}`}>
        {posts.map(post => (
            <li key={post.filename}>
                <NavLink
                    to={`/posts/${post.filename}`}
                    className={({ isActive }) => `block leading-snug transition-colors ${isActive ? `text-accent` : `text-slate-300 hover:text-white`}`}
                >
                    <span className="block mb-1 text-xs tabular-nums tracking-wide text-slate-500">{post.date}</span>
                    {post.title}
                </NavLink>
            </li>
        ))}
    </ul>
);

export default PostList;
